import React from 'react';
import Image from 'next/image';
import { css, cx } from 'styled-system/css';

import Tooltip from '@shaojiang/components/Tooltip';

interface Props {
  name: string;
  showName?: boolean;
  displayedName?: string;
  badge?: string;
  width?: number;
  height?: number;
  className?: string;
}

const badgeStyle = css({
  position: 'absolute',
  top: '-1',
  right: '-2',
  px: '1.5',
  borderRadius: 'full',
  bg: 'highlight.main',
  color: 'white',
  textStyle: 'xs',
  fontWeight: 'semibold',
  lineHeight: '1.5',
  whiteSpace: 'nowrap',
  transform: 'translateX(25%)',
});

export default function ShaojiangTechIcon({
  name,
  showName = false,
  displayedName = '',
  badge,
  height = 48,
  width = 48,
  className,
}: Props) {
  return (
    <Tooltip title={name}>
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        })}
      >
        <div
          className={cx(
            css({
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              w: '12',
            }),
            showName && css({ h: '12' }),
            className,
          )}
        >
          <Image
            alt={name}
            width={width}
            height={height}
            src={`/icons/${name.toLowerCase()}.svg`}
          />
          {badge && <span className={badgeStyle}>{badge}</span>}
        </div>
        {showName && (
          <span className={css({ textStyle: 'xs', fontWeight: 'medium', whiteSpace: 'nowrap' })}>
            {displayedName || name}
          </span>
        )}
      </div>
    </Tooltip>
  );
}
